/* istanbul ignore file */

import { createSlice } from "@reduxjs/toolkit";


export type UserState = {
  user: {};
  question: null;
  answer: null;
  sourcesOpen: boolean;
  sources: any[];
  recommendeQuestions: [];
  feedback: {};
  interactionId: number;
  showSources: boolean;
  showAnswer: boolean;
  showRecommendedQuestions: boolean;
  showFeedback: boolean;
  chatHistoryId: number;
  showLoader: boolean;
  tempQuestion: null;
  showError: boolean;
  showRetryError: boolean;
  showUserManagementScreen:boolean
};

const initialState: UserState = {
  user: {},
  question: null,
  answer: null,
  sourcesOpen: false,
  feedback: {},
  interactionId: -1,
  showSources: false,
  showAnswer: false,
  showRecommendedQuestions: false,
  showFeedback: false,
  sources: [],
  recommendeQuestions: [],
  chatHistoryId: -1,
  showLoader: false,
  tempQuestion: null,
  showError: false,
  showRetryError: false,
  showUserManagementScreen:false
};

const userSlice = createSlice({
  // An unique name of a slice
  name: "askTim",

  // Initial state value of the reducer
  initialState,

  // Reducer methods
  reducers: {
    login(state, action) {
      state.user = action.payload;
    },

    logout() {
      console.log("calling logout");
      // persistor.purge();
      return initialState;
    },

    questionAsked(state, action) {
      state.question = action.payload;
      state.answer = null;
      state.feedback = {};
      state.interactionId = -1;
      state.showSources = false;
      state.showAnswer = false;
      state.showRecommendedQuestions = false;
      state.showFeedback = false;
      state.sources = [];
      state.recommendeQuestions = [];
      state.chatHistoryId = -1;
      state.showError = false;
      state.showRetryError = false;
      state.showUserManagementScreen=false;
    },
    setAnswer(state, action) {
      state.answer =
        state.answer === null || state.answer === ""
          ? action.payload || ""
          : state.answer + (action.payload || "");
    },
    setSources(state, action) {
      // console.log("setSources",action.payload)
      state.sources.push(action.payload);
    },
    resetSources(state, action) {
      state.sources = [];
    },
    setRecommendedQuestions(state, action) {
      state.recommendeQuestions = action.payload;
    },
    openSources(state) {
      state.sourcesOpen = true;
    },
    closeSources(state) {
      state.sourcesOpen = false;
    },
    submitFeedback(state, action) {
      state.feedback = action.payload;
    },
    setInteractionId(state, action) {
      state.interactionId = action.payload;
    },
    showSources(state) {
      state.showSources = true;
    },
    hideSources(state) {
      state.showSources = false;
    },
    showAnswer(state) {
      state.showAnswer = true;
    },
    hideAnswer(state) {
      state.showAnswer = false;
    },
    showRecommendedQuestions(state) {
      state.showRecommendedQuestions = true;
    },
    hideRecommendedQuestions(state) {
      state.showRecommendedQuestions = false;
    },
    showFeedback(state) {
      state.showFeedback = true;
    },
    hideFeedback(state) {
      state.showFeedback = false;
    },
    setInteractionValue(state, action) {
      state.question = action.payload.question;
      state.answer = action.payload.answer;
      state.sources = action.payload.sources;
      state.chatHistoryId = action.payload.chatHistoryId;
      state.feedback = action.payload.feedback;
      state.showRecommendedQuestions = false;
            state.showUserManagementScreen=false;

      if (action.payload.sources && action.payload.sources.length > 0) {
        state.showSources = true;
      }
    },
    showLoading(state) {
      state.showLoader = true;
    },
    hideLoading(state) {
      state.showLoader = false;
    },
    setQuestionInBox(state, action) {
      state.tempQuestion = action.payload;
    },
    resetQuestionInBox(state) {
      state.tempQuestion = null;
    },
    showError(state) {
      state.showError = true;
    },
    hideError(state) {
      state.showError = false;
    },
    showRetryErrorMsg(state) {
      console.log("showRetryErrorMsg called in slice to ste true");
      state.showRetryError = true;
    },
    hideRetryErrorMsg(state) {
      console.log("hideRetryErrorMsg called in clice to set false");
      state.showRetryError = false;
    },
    showUserManagementScreen(state) {
      state.showUserManagementScreen=true;
    },
    hideUserManagementScreen(state) {
      state.showUserManagementScreen=false;
    }
  },
});

// Action creators for each reducer method
export const {
  login,
  logout,
  questionAsked,
  openSources,
  closeSources,
  submitFeedback,
  setInteractionId,
  showSources,
  hideSources,
  showAnswer,
  hideAnswer,
  showRecommendedQuestions,
  hideRecommendedQuestions,
  showFeedback,
  hideFeedback,
  setAnswer,
  setSources,
  setRecommendedQuestions,
  setInteractionValue,
  resetSources,
  showLoading,
  hideLoading,
  setQuestionInBox,
  resetQuestionInBox,
  showError,
  hideError,
  showRetryErrorMsg,
  hideRetryErrorMsg,
  showUserManagementScreen,
  hideUserManagementScreen
} = userSlice.actions;

export default userSlice;
